import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webLive/www.seenrooftopbangkok.com/app/app/components/footer/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webLive/www.seenrooftopbangkok.com/app/app/components/header/index.js");
;
import(/* webpackMode: "eager" */ "/var/www/webLive/www.seenrooftopbangkok.com/app/app/styles/globals.scss");
;
import(/* webpackMode: "eager" */ "/var/www/webLive/www.seenrooftopbangkok.com/app/node_modules/bootstrap/dist/css/bootstrap.min.css");
;
import(/* webpackMode: "eager" */ "/var/www/webLive/www.seenrooftopbangkok.com/app/node_modules/next/dist/client/script.js");
